<div class="g_modal-dialog g_backdrop" (mousedown)="onBackdropClicked($event)">
    <div class="g_dialog-container info-modal-window"
         [ngClass]="model.dialogClass"
         (click)="$event.stopPropagation()"
         (mousedown)="$event.stopPropagation()">


        <div class="g_dialog-header">
            <div>{{ model.title }}</div>
            <button (click)="onDialogCancelBtnClicked()" class="btn btn-icon-only close-button" *ngIf="!model.hiddeCloseButton">
                <i class="fa fa-close"></i>
            </button>
        </div>


        <div class="g_dialog-content" [innerHTML]="model.htmlMessage">
        </div>

        <div class="g_dialog-footer">
            <button class="btn btn-secondary w-100" *ngIf="model?.cancelButtonLabel"  (click)="onCancelBtnClicked()">{{model.cancelButtonLabel}}</button>
            <button class="btn btn-primary w-100" *ngIf="model?.confirmButtonLabel"  (click)="onConfirmBtnClicked()">{{model.confirmButtonLabel}}</button>
        </div>
    </div>

</div>
